const en = {
  header: {
    languages: {
      swedish: 'Swedish',
      english: 'English'
    },
    logo: 'Logo'
  },
  common: {
    title: 'Grace Chan | Full-Stack Developer',
    name: 'Grace Chan'
  },
  home: {
    name: 'Home',
    title: 'Full-stack Developer ',
    focus: 'Front-end focused',
    arrow: 'Arrow',
    contacts: [
      {
        name: 'LinkedIn',
        link: 'https://www.linkedin.com/in/yintinggrace/',
        icon: 'fa-brands fa-linkedin',
        openNewTab: true
      },
      {
        name: 'GitHub',
        link: 'https://github.com/yintinggrace/',
        icon: 'fa-brands fa-github',
        openNewTab: true
      },
      {
        name: 'Email',
        link: 'mailto:yintingchancytg@gmail.com',
        icon: 'fa-solid fa-envelope',
        openNewTab: false
      }
    ],
    iSpecialiseIn: 'I specialise in',
    specialization: [
      {
        name: 'React',
        uri: 'react-negative.svg'
      },
      {
        name: 'Next.js',
        uri: 'next-js-negative.svg'
      },
      {
        name: 'TypeScript',
        uri: 'typescript-negative.svg'
      },
      {
        name: 'Node.js',
        uri: 'node-js-negative.svg'
      }
    ]
  },
  aboutMe: {
    name: 'About Me',
    facts: [
      {
        fact: 'Highly motivated React enthusiast crafting user interfaces for an elevated experience.',
        uri: 'react.png',
        alt: 'React'
      },
      {
        fact: 'I love teamwork — it is the key to reaching greater heights and making the journey more enjoyable!',
        uri: 'team.png',
        alt: 'Team'
      },
      {
        fact: 'More than coding—I integrate UX design for well-functioning, stylish websites.',
        uri: 'ux-ui.png',
        alt: 'UX/UI'
      },
      {
        fact: 'I shifted from social work to tech—making an impact is exhilarating!',
        uri: 'computer.png',
        alt: 'Computer'
      },
      {
        fact: 'Daytime code creator, nighttime artsy explorer, on holiday an adventurous traveller.',
        uri: 'fun.png',
        alt: 'Hobbies'
      },
      {
        fact: 'Coffee is cool, but I am sticking to tea all day.',
        uri: 'tea.png',
        alt: 'Tea'
      }
    ]
  },
  skills: {
    name: 'Skills',
    filterBtn: 'Filter',
    selectAll: 'Select All',
    unselectAll: 'Unselect All',
    categories: [
      {
        category: 'Programming Languages',
        content: [
          {
            name: 'C#',
            uri: 'c-sharp.svg'
          },
          {
            name: 'CSS',
            uri: 'css.svg'
          },
          {
            name: 'HTML',
            uri: 'html.svg'
          },
          {
            name: 'Java',
            uri: 'java.svg'
          },
          {
            name: 'JavaScript',
            uri: 'javascript.svg'
          },
          {
            name: 'PHP',
            uri: 'php.svg'
          },
          {
            name: 'TypeScript',
            uri: 'typescript.svg'
          }
        ]
      },
      {
        category: 'Frameworks & Libraries',
        content: [
          {
            name: 'Axios',
            uri: 'axios.svg'
          },
          {
            name: 'D3',
            uri: 'd3.svg'
          },
          {
            name: 'Express.js',
            uri: 'express-js.svg'
          },
          {
            name: 'Fastify',
            uri: 'fastify.svg'
          },
          {
            name: 'Font Awesome',
            uri: 'font-awesome.svg'
          },
          {
            name: 'i18next',
            uri: 'i18next.svg'
          },
          {
            name: 'Material UI',
            uri: 'mui.svg'
          },
          {
            name: 'Next.js',
            uri: 'next-js.svg'
          },
          {
            name: 'Node.js',
            uri: 'node-js.svg'
          },
          {
            name: 'PropTypes'
          },
          {
            name: 'React',
            uri: 'react.svg'
          },
          {
            name: 'React Router',
            uri: 'react-router.svg'
          },
          {
            name: 'React Query',
            uri: 'react-query.svg'
          },
          {
            name: 'Redux',
            uri: 'redux.svg'
          },
          {
            name: 'shadcn/ui',
            uri: 'shadcnui.svg'
          },
          {
            name: 'Valtio'
          }
        ]
      },
      {
        category: 'Styling & Layout',
        content: [
          {
            name: 'Responsive Web Design'
          },
          {
            name: 'Sass',
            uri: 'sass.svg'
          },
          {
            name: 'styled-components',
            uri: 'styled-components.svg'
          },
          {
            name: 'Tailwind CSS',
            uri: 'tailwind-css.svg'
          }
        ]
      },
      {
        category: 'Databases & Data Handling',
        content: [
          {
            name: 'JSON',
            uri: 'json.svg'
          },
          {
            name: 'REST API'
          },
          {
            name: 'PostgreSQL',
            uri: 'postgresql.svg'
          },
          {
            name: 'SQL'
          }
        ]
      },
      {
        category: 'Testing',
        content: [
          {
            name: 'Jest',
            uri: 'jest.svg'
          },
          {
            name: 'Playwright',
            uri: 'playwright.svg'
          }
        ]
      },
      {
        category: 'Development Tools',
        content: [
          {
            name: 'Docker',
            uri: 'docker.svg'
          },
          {
            name: 'ESLint',
            uri: 'eslint.svg'
          },
          {
            name: 'Git',
            uri: 'git.svg'
          },
          {
            name: 'GitHub',
            uri: 'github.svg'
          },
          {
            name: 'Google DevTools'
          },
          {
            name: 'IntelliJ IDEA',
            uri: 'intellij-idea.svg'
          },
          {
            name: 'npm',
            uri: 'npm.svg'
          },
          {
            name: 'Postman',
            uri: 'postman.svg'
          },
          {
            name: 'Visual Studio Code',
            uri: 'vs-code.svg'
          },
          {
            name: 'WordPress',
            uri: 'wordpress.svg'
          }
        ]
      },
      {
        category: 'Other Technologies',
        content: [
          {
            name: 'bash',
            uri: 'bash.png'
          },
          {
            name: 'FTP'
          },
          {
            name: 'Markdown',
            uri: 'markdown.svg'
          }
        ]
      },
      {
        category: 'UX/UI Design & Prototyping Tools',
        content: [
          {
            name: 'Figma',
            uri: 'figma.svg'
          },
          {
            name: 'Miro',
            uri: 'miro.svg'
          },
          {
            name: 'Personas'
          },
          {
            name: 'Procreate',
            uri: 'procreate.svg'
          },
          {
            name: 'UML',
            uri: 'uml.svg'
          },
          {
            name: 'UX & UI Design'
          }
        ]
      },
      {
        category: 'Collaboration Tools',
        content: [
          {
            name: 'Confluence',
            uri: 'confluence.svg'
          },
          {
            name: 'Jira',
            uri: 'jira.svg'
          },
          {
            name: 'Microsoft Teams',
            uri: 'microsoft-teams.svg'
          },
          {
            name: 'Slack',
            uri: 'slack.svg'
          },
          {
            name: 'Trello',
            uri: 'trello.svg'
          }
        ]
      },
      {
        category: 'General Skills',
        content: [
          {
            name: 'Agile Methodology'
          },
          {
            name: 'Block Element Modifier',
            uri: 'bem.svg'
          },
          {
            name: 'Business Model Canvas'
          },
          {
            name: 'Scrum'
          }
        ]
      },
      {
        category: 'Languages',
        content: [
          {
            name: 'Swedish',
            uri: 'swedish.png',
            description: 'Fluent'
          },
          {
            name: 'English',
            uri: 'english.png',
            description: 'Fluent'
          },
          {
            name: 'Cantonese',
            uri: 'cantonese.png',
            description: 'Native'
          },
          {
            name: 'Mandarin',
            uri: 'mandarin.png',
            description: 'Fluent'
          }
        ]
      },
      {
        category: 'Hobbies',
        content: [
          {
            name: 'Art and crafting'
          },
          {
            name: 'Fitness'
          },
          {
            name: 'Food and drink'
          },
          {
            name: 'Travelling'
          },
          {
            name: 'Video games'
          },
          {
            name: 'Volunteering'
          },
          {
            name: 'Web development'
          }
        ]
      }
    ]
  },
  projects: {
    name: 'Projects',
    description: 'Description',
    skills: 'Skills',
    showDemo: 'Show Demo',
    gitHub: 'GitHub',
    comingSoon: 'Coming Soon',
    folders: [
      {
        name: 'Portfolio',
        uri: 'portfolio.png',
        description: 'A personal portfolio website displaying my work, skills, and contact information.',
        skills: 'React, prop-types, Sass, i18n, React Router',
        alt: 'Portfolio'
      },
      {
        name: 'Action Ally',
        gitHub: 'https://github.com/yintinggrace/action-ally',
        uri: 'action-ally.png',
        description: 'A to-do list app for easy task management. Users can select logos for categories, enhancing organisation and personalisation.',
        skills: 'React, TypeScript, styled-components, React Router',
        demo: 'https://www.gracechan.se/projects/action-ally',
        alt: 'Action Ally'
      },
      {
        name: 'Conference Compass',
        gitHub: 'https://github.com/ericalundstrom/DataBaseProject',
        uri: 'conference-compass.png',
        description: 'A lively platform where authors submit papers, admins assign reviewers, and reviewers give their expert takes to make conference planning smoother.',
        skills: 'Node.js, Express.js, PostgreSQL, EJS, Agile Project Management',
        alt: 'Conference Compass'
      },
      {
        name: 'Nalle Puh',
        gitHub: 'https://github.com/yintinggrace/NallePuh',
        uri: 'nalle-puh.png',
        description: 'An adventurous treasure hunt website where young children join the quest to save Winnie the Pooh’s honey in Folket Park.',
        skills: 'HTML, CSS, JavaScript, Agile Project Management',
        alt: 'Nalle Puh'
      },
      {
        name: 'Women In Tech Alliance',
        uri: 'WITA.png',
        description: 'A community website dedicated to empowering women in tech by fostering connections, innovation, and growth across industries.',
        skills: 'CMS Management, CSS, JavaScript, UX',
        demo: 'https://womenintechalliance.com/',
        alt: 'WITA'
      },
      {
        name: 'Queer Youth Uganda',
        uri: 'QYU.png',
        description: 'An educational platform empowering Uganda’s LGBTQ community with resources, storytelling, and safe online connections.',
        skills: 'CMS Management, CSS, JavaScript, UX, SEO, Project & Client Management, Agile Project Management',
        demo: 'https://queeryouthuganda.com/',
        alt: 'QYU'
      },
      {
        name: 'Chic Closet',
        gitHub: 'https://github.com/yintinggrace/chiccloset',
        uri: 'chiccloset.png',
        description: 'An internal admin platform for Chic Closet, enabling administrators to fetch products from the server, add new items, update existing items, and remove products from the store’s catalog.',
        skills: 'React, React Query, TypeScript, Material UI, REST API, Axios',
        demo: 'https://www.gracechan.se/projects/chic-closet',
        alt: 'Chic Closet'
      },
      {
        name: 'Cinephile',
        uri: 'cinephile.png',
        description: 'A sleek movie discovery app that lets users explore the  trending movies of the week and browse by genre, powered by real-time data from The Movie Database (TMDB).',
        skills: 'React, TypeScript, Next.js, Material UI, REST API',
        alt: 'Movie Database App',
        comingSoon: true
      },
      {
        name: 'Weathery',
        uri: 'weathery.png',
        description: 'A weather application that provides daily temperature and forecasts for any city.',
        skills: 'React, TypeScript, Tailwind CSS, React Router',
        alt: 'Weather App',
        comingSoon: true
      }
    ]
  }
};

export default en;
